import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AuthGuard} from './Shared/AuthGuards/auth.guard';
import { AppComponent }  from './app.component';
import { DashboardLayoutComponent}  from './Components/dashboard/dashboardlayout.component';
import { HomeComponent}  from './Components/dashboard/home.component';
import {BusinessUnitComponent} from './Components/BusinessUnit/business.unit';
import { LoginComponent } from './Components/login/index';
import { SeedDataComponent  } from './Components/SeedData/seed.data';
import { ProfileComponent  } from './Components/TeamMember/Profile';
import { TeamMemberComponent  } from './Components/TeamMemberManagement/TeamMember';
import {RolesComponent} from './Components/Roles/Roles';
import { UserCreationComponent } from './Components/UserManagement/UserCreation';
import { PermissionsComponent } from './Components/Permissions/Permissions';
import { PageNotFoundComponent } from './Shared/PageNotFound/page-not-found.component';
import { ForgotpasswordComponent } from './Components/login/forgotpassword.component';
import {DeliveryunitComponent} from './Components/DeliveryUnit/delivery.unit';
import {UserDetailsComponent} from './Components/UserDetails/UserDetails';
import {TeamMemberDirectoryComponent} from './Components/team-member-directory/team-member-directory.component';
import { HRBPDetailsComponent } from './Components/HRBusinessPartner/HRBPDetails.component';
import { LoginviatranscendComponent } from './loginviatranscend/loginviatranscend.component';
import { TeamHierarchyComponent } from './Components/TeamHierarchy/TeamHierarchy';
import { PriorRelevantExperienceComponent } from './Components/prior-relevant-experience/prior-relevant-experience.component';
import { PoliciesComponent } from './Components/Policies/policies.component';
import { PolicyViewerComponent } from './Components/PolicyViewer/policy-viewer.component';

const appRoutes: Routes = [

    { path: '', component: LoginComponent/*, useAsDefault: true*/  },
                                    

    { path: 'login', component: LoginComponent},

    {
      path: 'home', component: DashboardLayoutComponent, canActivate: [AuthGuard],
      children: [
            {
              path: '', component: HomeComponent, canActivate: [AuthGuard]
            }
        ]
        
    },

    {
        path: 'teammemberdirectory',
        component: DashboardLayoutComponent,
        canActivate: [AuthGuard],
        children: [{ path: '', component: TeamMemberDirectoryComponent }]

    },
   
    {
        path: 'delivery-unit',
        component: DashboardLayoutComponent,
        canActivate: [AuthGuard],
        children: [{ path: '', component: DeliveryunitComponent}]
    },

    {
        path: 'seed-data',
        component: DashboardLayoutComponent,
        canActivate: [AuthGuard],
        children: [{ path: '', component: SeedDataComponent}]
    },

    {
        path: 'profile',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: ProfileComponent}]
    },
    {
        path: 'team-member',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: TeamMemberComponent }]
    },
    {
        path: 'roles',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: RolesComponent }]
    },
    {
        path: 'user',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: UserCreationComponent }]
    }
    ,
    {
        path: 'userlist',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: UserCreationComponent }]
    }
    ,  
    {
        path: 'permissions',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: PermissionsComponent }]
    },  
    {
        path: 'ForgotPassword',
        component: ForgotpasswordComponent 
    },
    {
        path: 'ForgotPassword:token',
        component: ForgotpasswordComponent
    },

    {
        path: 'profile/:Id',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: ProfileComponent }]
    },

    {
        path: 'updateprofileadmin/:UserId',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: ProfileComponent }]
    },
    {
        path: 'userdetails',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: UserDetailsComponent }]
    },
    {
        path: 'userdetails/:UserId',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: UserDetailsComponent }]
    },
    {
        path: 'hrbpdetails',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: HRBPDetailsComponent }]
    },
    {
        path: 'teamhierarchy',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: TeamHierarchyComponent }]
    },
    {
        path: 'teamhierarchy/:userId',
        component: DashboardLayoutComponent, canActivate: [AuthGuard],
        children: [{ path: '', component: TeamHierarchyComponent }]
    },
    {
        path: 'loginviatranscend',
        component: LoginviatranscendComponent,
       
         },
         {
            path: 'prior-relevant-experience',
            component: DashboardLayoutComponent, canActivate: [AuthGuard],
            children: [{ path: '', component: PriorRelevantExperienceComponent }]
        },
        {
            path: 'policies',
            component: DashboardLayoutComponent, canActivate: [AuthGuard],
            children: [{ path: '', component: PoliciesComponent }]
        },
        {
            path: 'policies/view/:id',
            component: DashboardLayoutComponent, canActivate: [AuthGuard],
            children: [{ path: '', component: PolicyViewerComponent }]
        },
        {
    path: 'compass',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuard]
},
        
    { path: '**', component: PageNotFoundComponent },

   
    
    //{ path: '**', redirectTo: '/', pathMatch: 'full' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { useHash: true })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule  { }


// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts